<div class="info">
    <div class="container head">
        <div class="col-lg-12">
            <h3 class="heading">LIVRAISON {{family|uppercase}} {{zone|uppercase}} {{postalCode}}</h3>
            <hr class="half_space">
            <h4>{{pdv}}</h4>
            <p>Commander dans votre restaurant préféré directement en ligne sur notre site web:
                <b>{{host}}</b></p>
            <p>Vous habitez à <b>{{zone|uppercase}}</b> et vous recherchez un restaurant qui vous livre des plats de
                qualités?
                Prenez quelques secondes pour commander sur le site et laissez vous tenter par l'un de nos plats.</p>
            <p>Le site vous permet de commander directement en ligne. Vous y retrouvez toutes nos spécialités, les prix
                de vos plats préférés et bien sur le récapitulatif de votre commande.</p>
            <p>Votre restaurant vous livre à domicile ou au bureau.</p>
            <p>Vous travaillez en entreprise et souhaitez déjeuner au bureau de bon plats confectionnés avec soin?
                Passez commande sur notre site web <b>{{host}}</b> en quelques clics.</p>
            <p>Vous êtes à la maison et vous aimeriez qu'on vous livre rapidement nos spécialités? Notre équipe saura
                vous offrir un service de qualité tout en vous livrant le plus rapidement possible.</p>
            <p>Aujourd'hui c'est le match de l'année et vous souhaitez vous retrouvez entre amis pour le regarder et
                vous faire livrer à domicile? Passez commande sur notre site web <b>{{host}}</b>.</p>
            <p>Tout les jours, votre restaurant fait le maximum pour vous assurer une livraison rapide, à votre
                domicile, au bureau ou chez vos amis.</p>
            <p>Votre restaurant vous livre dans la ville de <b>{{zone|uppercase}}</b> ses spécialités:
                <ng-container *ngFor="let family of families;let i=index">{{family.label|uppercase}}
                    <ng-container *ngIf="(families.length-1)==i">
                        .
                    </ng-container>
                    <ng-container *ngIf="(families.length-1)!=i">
                        ,
                    </ng-container>
                </ng-container>
                Vous n'habitez pas à <b>{{zone|uppercase}}</b> ? Pas de panique, nous livrons également <b
                    *ngFor="let zone of authorizedCities; let i = index">{{ zone.name }}
                    {{ zone.postalCode }} ,</b></p>
            <p>Toute l'équipe de nom du restaurant est heureuse de vous accueillir et de vous servir.</p>
        </div>
    </div>
</div>